// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"8f0247fa","276":"6082810a"}[chunkId] + ".chunk.css";
};